import { ArrayFieldTemplateProps } from "@rjsf/utils";
import { Row, Col } from "antd";
import { MinusIcon } from "@heroicons/react/24/outline";
import { PlusIcon } from "@heroicons/react/24/outline";

export default function StyledArrayFieldTemplate({
  items,
  onAddClick,
  canAdd,
}: ArrayFieldTemplateProps) {
  return (
    <div className="custom-object-field-template ">
      <Row gutter={6}>
        <Col span={24}>
          {items &&
            items.map((element, index) => {
              return (
                <div
                  key={index}
                  className="custom-array-item flex flex-row items-center justify-start"
                >
                  {element.children}
                  <button
                    onClick={element.onDropIndexClick(index)}
                    className="button-secondary py-1 px-1 rounded-lg text-white ml-8 mt-8 hover:text-secondary_600"
                  >
                    <MinusIcon className="h-4 w-4" />
                  </button>
                </div>
              );
            })}
        </Col>
        {canAdd && (
          <Row className="flex flex-row items-start justify-start mt-4 ml-2 w-full ">
            <button
              onClick={onAddClick}
              className="button-primary border-2 py-1 px-2 text-white rounded-xl border-primary_800  hover:bg-white hover:text-primary_900 hover:border-primary_900 active:text-primary_900"
            >
              <PlusIcon className="h-4 w-4 " />
            </button>
          </Row>
        )}
      </Row>
    </div>
  );
}
